import React from 'react'

import { useVisibleDevices } from '@data/device/device'
import ESGComponent from '../Components/ESG/ESGComponent'

const ESGReport: React.FC = () => {
  const devices = useVisibleDevices()

  return (
    <div>
      <ESGComponent devices={devices} />
    </div>
  )
}

export default ESGReport
